import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Checkbox } from '../../../../primitives/Checkbox/index.js';
import { Container } from '../../../../primitives/Select/components/Option/components/Container.js';
export const Option = props => {
  const {
    isFocused,
    isSelected,
    isDisabled,
    innerRef,
    innerProps,
    selectProps,
    getStyles,
    label,
    isMulti
  } = props;
  const {
    size
  } = selectProps;
  return _jsxs(Container, {
    ref: innerRef,
    reactSelectStyles: getStyles('option', props),
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled,
    isMulti: isMulti,
    size: size,
    ...innerProps,
    children: [isMulti && _jsx(Checkbox, {
      checked: isSelected,
      disabled: isDisabled
    }), label]
  });
};